// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3xwdp","paramInput":"JobSimulator_paramInput__3unAz","input":"JobSimulator_input__3E-_c"};